import axios from "axios";
import { parseResponse, parseError } from '../utils/parseResponse';

function normalizeApiBaseUrl(raw) {
    if (typeof raw !== 'string') {
        return '';
    }
    return raw.trim().replace(/\/+$/, '');
}

function isHttpOrigin(value) {
    // URL parsing repairs missing slashes, but Axios receives this raw string.
    if (!/^https?:\/\//i.test(value)) return false;
    try {
        const url = new URL(value);
        return (url.protocol === 'http:' || url.protocol === 'https:') && !value.includes('?') && !value.includes('#');
    } catch {
        return false;
    }
}

export const getShowerMeetingDetails = async (meeting_Id, options = {}) => {
    const baseUrl = normalizeApiBaseUrl(process.env.REACT_APP_API_URL);

    // Without a real absolute base URL, `${undefined}/?cmd=...` becomes the path
    // "undefined/" and resolves relative to the page (e.g. /meeting/undefined/).
    if (!isHttpOrigin(baseUrl)) {
        return {
            ...parseError({
                response: {
                    status: 400,
                    data: {
                        message:
                            'REACT_APP_API_URL must be an absolute http:// or https:// backend URL without a query or fragment. Check .env.local in the project root (see env.example).',
                    },
                },
            }),
            configurationError: true,
        };
    }

    return axios({
        url: `${baseUrl}/?cmd=video.getShowerMeetingDetails`,
        method: 'post',
        // Only the theme depends on this call; don't let a hung request hold up joining.
        timeout: 10000,
        params: {
            meetingId: meeting_Id,
        },
        ...(options.signal ? { signal: options.signal } : {}),
        ...(options.timeout ? { timeout: options.timeout } : {}),
    })
        .then(parseResponse)
        .catch(parseError);
}
